<template>
  <el-dialog
    :title="title"
    width="50%"
    :visible.sync="visible"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="50px">
      <el-form-item label="名称">
        <el-input
          v-model="form.name"
          maxlength="100"
          placeholder="最长可输入100字"
        ></el-input>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
    >
      <el-button type="primary" v-if="this.type == '1'" @click="submitForm"
        >确 定</el-button
      >
      <el-button type="primary" v-if="this.type == '2'" @click="submitForm2"
        >确 定</el-button
      >
      <el-button type="" @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { http } from '@/utils/axios'
export default {
  props: ['userType'],
  name: 'CourseAddChapter',
  data() {
    return {
      visible: false,
      title: '',
      form: {
        name: '',
      },
      type: '',
    }
  },
  methods: {
    getList() {},

    // 初始化
    init(type, name) {
      //type1新增  2编辑  name回显的名字
      this.type = type
      this.visible = true
      if (type == '1') {
        this.form.name = ''
        this.title = '添加章节'
      } else {
        this.title = '编辑章节'
        this.form.name = name
      }
    },

    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      // this.$emit('close-registration-review-edit', msg)
    },

    // 提交
    submitForm() {
      if (this.form.name == '') {
        this.$message({ type: 'error', message: `请输入名称` })
      } else {
        this.visible = false
        this.$emit('getChapterName', this.form.name)
      }
    },
    submitForm2() {
      if (this.form.name == '') {
        this.$message({ type: 'error', message: `请输入名称` })
      } else {
        this.visible = false
        this.$emit('editChapterName', this.form.name)
      }
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  width: 60%;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
</style>
